import { handleActions, Action } from 'redux-actions';

import { EmptyCar } from 'app/models';
import { EmptyCarActions } from 'app/actions';

//constants
const initialState: EmptyCar.State = {
	isLoading: false,
	isOpen: false,
	data: null,
	error: null,
};

//----------------------------------------------------------
// emptyCarReducer
//----------------------------------------------------------
const emptyCarReducer = handleActions<EmptyCar.State, any>(
	{
		[EmptyCarActions.Action.UPDATE_BASE_DATA]: (state, { payload }: Action<Partial<EmptyCar.Base>>) => {
			if (state.data && payload) {
				return {
					...state,
					data: {
						...state.data,
						base: {
							...state.data.base,
							...payload,
						},
					},
				};
			} else return state;
		},
		[EmptyCarActions.Action.UPDATE_TRANSPORT_DATA]: (state, { payload }: Action<Partial<EmptyCar.Certificate>>) => {
			if (state.data && payload) {
				const documents = state.data.documents || {};

				return {
					...state,
					data: {
						...state.data,
						documents: {
							...documents,
							transport: {
								...(documents.transport || { kind: '' }),
								...payload,
							},
						},
					},
				};
			} else return state;
		},
		[EmptyCarActions.Action.UPDATE_TRAILER_DATA]: (state, { payload }: Action<Partial<EmptyCar.Certificate>>) => {
			if (state.data && payload) {
				const documents = state.data?.documents || {};

				return {
					...state,
					data: {
						...state.data,
						documents: {
							...documents,
							trailer: {
								...(documents.trailer || { kind: '' }),
								...payload,
							},
						},
					},
				};
			} else return state;
		},
		[EmptyCarActions.Action.UPDATE_INSURANCE_DATA]: (state, { payload }: Action<EmptyCar.Insurance>) => {
			if (state.data && payload) {
				const documents = state.data?.documents || {};

				return {
					...state,
					data: {
						...state.data,
						documents: {
							...documents,
							insurance: {
								...(documents?.insurance || { expiredAt: null, issuedAt: null, number: null }),
								...payload,
							},
						},
					},
				};
			} else return state;
		},
		[EmptyCarActions.Action.UPDATE_DIMENSIONS_DATA]: (state, { payload }: Action<EmptyCar.Dimensions>) => {
			if (state.data && payload) {
				return {
					...state,
					data: {
						...state.data,
						dimensions: {
							...(state.data?.dimensions || {}),
							...payload,
						},
					},
				};
			} else return state;
		},
		[EmptyCarActions.Action.ADD_EMPTY_CAR]: (state, { payload }: Action<EmptyCar.Data>) => ({
			...state,
			data: payload || null,
		}),
		[EmptyCarActions.Action.DELETE_EMPTY_CAR]: (state) => ({
			...state,
			isOpen: false,
			data: null,
		}),
		[EmptyCarActions.Action.SET_OPENED_STATE]: (state, { payload = false }: Action<boolean>) => ({
			...state,
			isOpen: payload,
		}),
		[EmptyCarActions.Action.SET_LOADING_STATE]: (state, { payload = false }: Action<boolean>) => ({
			...state,
			isLoading: payload,
		}),
	},
	initialState,
);

export default emptyCarReducer;
